import Units                      from 'scripts/defa/units/collection-units';
import UnitController             from 'scripts/defa/units/controller-unit-controller';
import Unit                       from 'scripts/defa/units/model-unit';
import UnitRouter                 from 'scripts/defa/units/router-unit-router';
import UnitAliasForm              from 'scripts/defa/units/view-unit-alias-form';
import UnitCollectionView         from 'scripts/defa/units/view-unit-collection-view';
import UnitComplaintFlow          from 'scripts/defa/units/view-unit-complaint-flow';
import UnitContainer              from 'scripts/defa/units/view-unit-container';
import UnitDeleteForm             from 'scripts/defa/units/view-unit-delete-form';
import UnitInfoView               from 'scripts/defa/units/view-unit-info-view.js';
import UnitNativeChoiceView       from 'scripts/defa/units/view-unit-native-choice-view';
import UnitResetForm              from 'scripts/defa/units/view-unit-reset-form';
import UnitSearchHelpView         from 'scripts/defa/units/view-unit-search-help-view';
import UnitSearchRegistrationForm from 'scripts/defa/units/view-unit-search-registration-form';
import UnitSearchSerialForm       from 'scripts/defa/units/view-unit-search-serial-form';
import UnitSettingsBluetoothPanel from 'scripts/defa/units/view-unit-settings-bluetooth-panel';
import UnitSnippet                from 'scripts/defa/units/view-unit-snippet';
import UnitsInstalledFlow         from 'scripts/defa/units/view-units-installed-flow';
import Module                     from 'scripts/module';

const UnitsModule = new Module( 'UnitsModule', {
	collections: {
		Units
	},
	controllers: {
		UnitController
	},
	models     : {
		Unit
	},
	routers    : {
		UnitRouter
	},
	views      : {
		UnitAliasForm,
		UnitCollectionView,
		UnitComplaintFlow,
		UnitContainer,
		UnitDeleteForm,
		UnitInfoView,
		UnitNativeChoiceView,
		UnitResetForm,
		UnitSearchHelpView,
		UnitSearchRegistrationForm,
		UnitSearchSerialForm,
		UnitSettingsBluetoothPanel,
		UnitSnippet,
		UnitsInstalledFlow
	}
} );
export default UnitsModule;